import React from 'react';
import { Container } from 'reactstrap';

import NavigationBar from '../../components/NavigationBar/NavigationBar';

const Header = (props) => (
    <header>
        <Container className="p-0">
            <NavigationBar {...props} />
        </Container>
    </header>
);

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.js